// src/pages/Landing.js
import React, { useState } from 'react';
import PublicHeader from '../components/PublicHeader';
import { Link } from 'react-router-dom';
import '../styles.css';
import Footer from '../components/Footer';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from '../firebase';

export default function Landing() {
  return (
    <>
      <PublicHeader />

      {/* HERO */}
      <section className="landing-hero">
        <h1>Track Every Change.<br />Improve Every Lap.</h1>
        <p style={{ fontSize: '1.5rem', maxWidth: '800px', margin: '0 auto 40px', color: '#f5f5f5' }}>
          The ultimate motorsport setup sheet & data tracker for track-day warriors to professional teams.
        </p>
        <Link to="/register" className="btn btn-save" style={{ padding: '18px 48px', fontSize: '1.4rem' }}>
          Start Free Trial
        </Link>
      </section>

      {/* MAIN 4 FULL-WIDTH CARDS */}
      <section className="features-main">
        <div className="feature-full">
          <div className="feature-text">
            <h2>Track Setup Changes</h2>
            <p>Log every adjustment — suspension, aero, tires, gearing — between sessions so you always know what changed and why.</p>
          </div>
          <div className="feature-image">
            <img src="/images/highlight-setup.jpg" alt="Setup changes" />
          </div>
        </div>

        <div className="feature-full reverse">
          <div className="feature-text">
            <h2>Extensive Setup History</h2>
            <p>Compare any two setups side-by-side. See exactly what was different when you found those extra tenths.</p>
          </div>
          <div className="feature-image">
            <img src="/images/highlight-history.jpg" alt="Setup history" />
          </div>
        </div>

        <div className="feature-full">
          <div className="feature-text">
            <h2>Desktop, Tablet or Mobile</h2>
            <p>No matter your workflow, our app works seamlessly across all your devices. So much faster than pen and paper, you'll wonder why you ever used anything else.</p>
          </div>
          <div className="feature-image">
            <img src="/images/highlight-devices.jpg" alt="Multi-device" />
          </div>
        </div>

        <div className="feature-full reverse">
          <div className="feature-text">
            <h2>Data Integrity</h2>
            <p>Data is backed up in the cloud, and you can also download your data any time. Your data. Forever.</p>
          </div>
          <div className="feature-image">
            <img src="/images/highlight-trackmap.jpg" alt="Track map notes" />
          </div>
        </div>
      </section>

      {/* DETAILED FEATURES SECTION */}
      <section className="detailed-features">
        <div className="container">
          <h2 className="section-title">Everything you need to go faster</h2>

          <div className="detail-grid">
            <div className="detail-item">
              <img src="/images/highlight-compensations.jpg" alt="Compensations" />
              <h3>Compensations For Faster Setup Changes <span className="pro-badge">Pro</span></h3>
              <p>User-defined compensations let you adjust multiple parameters at once — perfect when you only have minutes between sessions.</p>
            </div>

            <div className="detail-item">
              <img src="/images/highlight-calculators.jpg" alt="Engineering Tools" />
              <h3>Engineering Tools</h3>
              <p>3D suspension kinematics, EV battery sizing, brake bias, wheel rate, tire size and alignment tools — and they import straight from your vehicle data.</p>
            </div>

            <div className="detail-item">
              <img src="/images/highlight-session-data.jpg" alt="Session data" />
              <h3>Session Data & Lap Times</h3>
              <p>Instantly log local weather conditions and easily add lap times and notes for each session.</p>
            </div>

            <div className="detail-item">
              <img src="/images/highlight-pdf-export.jpg" alt="PDF export" />
              <h3>Complete Setup History <span className="pro-badge">Pro</span></h3>
              <p>View the complete setup history of your vehicle, plus you can export to Excel.</p>
            </div>

            <div className="detail-item">
              <img src="/images/highlight-team-sharing.jpg" alt="Team sharing" />
              <h3>Team Sharing & Collaboration (Coming Soon)<span className="pro-badge">Pro</span></h3>
              <p>Invite team members, and collaborate on the same setups in real time, with user identified changes.</p>
            </div>

            <div className="detail-item">
              <img src="/images/highlight-offline.jpg" alt="Offline" />
              <h3>Tire Management<span className="pro-badge">Pro</span></h3>
              <p>Track the life and usage of each individual tire. Which corner, which session, how old, how many laps. All of it. Automatically.</p>
            </div>
          </div>

          <div style={{ textAlign: 'center', marginTop: '80px' }}>
            <Link to="/register" className="btn btn-save" style={{ padding: '18px 48px', fontSize: '1.4rem' }}>
              Start Free Trial
            </Link>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}